import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { APP_ENVIRONMENT, AppEnvironment, getAppUri, getShureCloudUri } from '@shure/cloud/shared/utils/config';

@Injectable({ providedIn: 'root' })
export class CloudNavigationService {
	constructor(
		private readonly router: Router,
		@Inject(APP_ENVIRONMENT) private readonly appEnv: AppEnvironment
	) {}

	/**
	 * Gets the full Shure Cloud URL for a given path using the shureCloudUriMap environment field
	 * @param path the path segment of the URL
	 * @returns the full Shure Cloud URL
	 */
	public getShureCloudUrl(path = ''): string {
		if (this.appEnv.shureCloudUriMap) {
			let baseUrl = getShureCloudUri(window.location.origin, this.appEnv.shureCloudUriMap);
			if (baseUrl?.endsWith('/')) {
				baseUrl = baseUrl.substring(0, baseUrl.length - 1);
			}

			return `${baseUrl}${path}`;
		}

		return '';
	}

	/**
	 * Navigates to a URL in the Shure Cloud application, regardless of which application triggers the navigation.
	 * If the app provides a shureCloudUriMap in its environment, we assume that we are NOT in the Shure Cloud
	 * app, so we treat it as an external navigation using window.location.assign(). Otherwise, we treat it
	 * as an internal navigation using Angular's router.
	 * @param path the URL path to navigate to
	 */
	public toShureCloudUrl(path = ''): string {
		if (this.appEnv.shureCloudUriMap) {
			const shureCloudUrl = this.getShureCloudUrl(path);
			window.open(shureCloudUrl, '_blank');
		} else {
			this.router.navigateByUrl(path);
		}

		return '';
	}

	/**
	 * formulate and return URL based on the appName provided.
	 * @param path the URL path to navigate to
	 * @param appName name of the application for which url should be navigated
	 * @param orgId orgId organization id required for applications
	 * @returns string representation of Url
	 */
	public getNavigationUrl(path = '', appName: string, orgId = ''): string {
		if (this.appEnv.appUriMap) {
			let baseUrl = getAppUri(window.location.origin, this.appEnv.appUriMap[appName]);
			if (baseUrl?.endsWith('/')) {
				baseUrl = baseUrl.substring(0, baseUrl.length - 1);
			}

			return `${baseUrl}${path}${orgId}`;
		}
		return '';
	}
}
